import React from "react";

import { Icon, Svg, Typography } from "components";

type SoilSightMarginChartProps = {
  caption: string;
  calloutValue: string;
  calloutDescription: string;
  chartLabel: string;
  legend: { baseline: string; change: string };
  captionIconName?: string;
  className?: string;
};

// Every string comes from the caller. The two surfaces frame the same chart differently ... one as a
// cost, the other as a lift.
export const SoilSightMarginChart = ({
  caption,
  calloutValue,
  calloutDescription,
  chartLabel,
  legend,
  captionIconName,
  className,
}: SoilSightMarginChartProps) => (
  <div className={`soilsight-margin-chart ${className ?? ""}`}>
    <div className="soilsight-margin-chart__caption">
      {captionIconName && <Icon iconName={captionIconName} size={30} className="soilsight-margin-chart__caption-icon" />}
      <Typography variant="h3" className="soilsight-margin-chart__caption-title">
        {caption}
      </Typography>
    </div>
    <div className="soilsight-margin-chart__card">
      <div className="soilsight-margin-chart__legend">
        <span className="soilsight-margin-chart__legend-item">
          <span className="soilsight-margin-chart__legend-dot soilsight-margin-chart__legend-dot--baseline" />
          <Typography variant="paragraph-s">{legend.baseline}</Typography>
        </span>
        <span className="soilsight-margin-chart__legend-item">
          <span className="soilsight-margin-chart__legend-dot soilsight-margin-chart__legend-dot--change" />
          <Typography variant="paragraph-s">{legend.change}</Typography>
        </span>
      </div>
      <div className="soilsight-margin-chart__plot" role="img" aria-label={chartLabel}>
        <Svg svgName="soilsight-pre-login/hero-cost-chart" className="soilsight-margin-chart__chart" />
      </div>
    </div>
    <div className="soilsight-margin-chart__callout">
      <Svg svgName="soilsight-pre-login/hero-callout-bracket" className="soilsight-margin-chart__callout-icon" />
      <div className="soilsight-margin-chart__callout-copy">
        <Typography variant="h3" className="soilsight-margin-chart__callout-value">
          {calloutValue}
        </Typography>
        <Typography variant="paragraph-m" className="soilsight-margin-chart__callout-description">
          {calloutDescription}
        </Typography>
      </div>
    </div>
  </div>
);
